module.exports = __webpack_public_path__ + "static/media/players-icon.1c992757.png";